import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/use-auth";
import { useFinalizeClaim } from "@/lib/tanstack-query/users";

/**
 * Auto-completes a claim for an invited applicant. Once they're authenticated on
 * a still-claimable account — i.e. they set a password via the claim link a pool
 * owner sent — flip the account from claimable to claimed. Runs at most once per
 * mount; invalidating the user afterwards clears `user.claim` so it won't repeat.
 * Renders nothing.
 */
export function ClaimFinalizer() {
  const { user } = useAuth();
  const { mutate: finalize } = useFinalizeClaim();
  const done = useRef(false);

  useEffect(() => {
    if (user?.claim && !done.current) {
      done.current = true;
      finalize();
    }
  }, [user?.claim, finalize]);

  return null;
}
